module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch02"
    }
  }, [_c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Chapter Two")])])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("P")])]), _vm._v("eople, drawn by the sound of the crash, were beginning to gather in a large circle around the two vehicles that had wound up crushed nose to nose. Clearly shaken but apparently unhurt, the fortyish driver of the SUV got out, a dazed expression beneath the day-old stubble on his face.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His eyes widened in fear when he saw that there was no movement in the front seat of the other, much smaller car. “I didn’t see her,” he cried to no one in particular. “I swear I didn’t see her pulling out.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A murmur of voices debated the visibility that had been afforded between the two vehicles as Sebastian pushed his way through the crowd, using his medical bag as a shield.")])]), _c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Let me through,” he ordered, fighting a sick feeling as his heart lodged itself in his throat. “I’m a doctor.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Exercising sheer determination, he forced himself not to react to the situation in any other manner except strictly professional. He was afraid to allow his fears free rein. They would only impede what might need to be done.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He didn’t like what he saw.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Stephanie’s eyes were shut when he yanked open the door on the driver’s side, and there was blood mingling with her blond hair from a cut on her forehead. The thought of internal injuries had his gut tightening in cold anticipation.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Stephanie, can you hear me?” he demanded roughly.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The voice reached out to her across a bridgeless chasm, pulling at her. Drawing her across.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It felt as if each of her eyelids weighed in at ten pounds each as she struggled to open them. She found that it took a concentrated effort to form words. Effort to cut through the pain that was tightening around her like a sharp-toothed vise, stealing her breath away. Stephanie had to push the words out.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You’re shouting,” she said hoarsely, each syllable throbbing in her head, making it ache. “Why shouldn’t I be able to hear you?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_vm._v("Relief spread over him in one huge, overwhelming ")]), _c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_vm._v("wave. She was conscious. Maybe the cut on her forehead was the worst of it.")])]), _c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Sebastian squatted down beside her, looking into her pupils. He saw no remarkable dilation. “Do you know what day it is?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Someone was pounding on her head with an anvil. She touched her hand to the pain and felt something sticky against her fingers.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Third worst day of my life.” She felt Sebastian remove her hand from her forehead. “Maybe the second,” she amended.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Concerning himself exclusively with her condition, he didn’t allow himself to speculate about what she was referring to. With sure, quick movements, Sebastian examined the cut on her forehead and decided it was minor, then passed his hands over each of her limbs to check for any breaks. There were none.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Stephanie found she had to fight to remain conscious. Her head insisted on sending things swirling around. Vaguely she felt Sebastian’s probing hands.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Hell of a time to get fresh with me, Sebastian,” she rasped weakly. “There’re witnesses.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His eyes met hers for a moment. She was teasing. For a second, he was propelled across the years, to another time, when teasing had reflected the easy feelings between them.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Just making sure nothing’s broken,” he assured her. His hand on hers, he sat back on his heels. “There doesn’t seem to be.”")])]), _c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It took two beats before her breath returned to her lungs. That had been a particularly bad one.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Wrong, Sherlock,” she managed to say. “I think my water just has.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Damn it, she was going into labor. He could see by the white-knuckled way Stephanie was clutching at his arm. He should have guessed as much. “You’re due?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Actually,” she gasped, bracing herself, afraid of another wave of pain, “I’m two weeks early.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Grabbing onto the steering wheel, Stephanie tried to drag herself out of the car using leverage. To her surprise, she felt Sebastian suddenly taking hold of her arms and easing her out of the vehicle.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her knees buckled and she would have sunk to the ground if he hadn’t been holding her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("This was it, she thought, trying vainly not to panic. Her heart began to hammer erratically.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Ignoring the people around them, ignoring the recent past, she returned to a place in her life when all she had was Sebastian and looked to him for help. She had no other choice.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Oh, God, Sebastian, I think they’re coming.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“They?” His eyes darted toward her belly. Multiple births? He’d thought she’d looked too large to be carrying just one.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She nodded her head and instantly regretted it as fresh pain assaulted her temples. “Twins. I’m having twins.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Great.")])])]), _c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He wouldn’t allow himself to emotionally dwell on it any longer than that. Looking over his shoulder, Sebastian singled out an older woman who was standing almost directly behind him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Call 911,” he instructed her. “We need an ambulance.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“We need a lot more than that,” Stephanie cried, digging her nails into his bare forearms as she struggled to keep from sinking into the pain again. “They are "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("really")]), _vm._v(" coming.” She couldn’t emphasize the word enough.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It was common for first-time mothers to panic, Sebastian thought, and Stephanie had just had an accident to strip away her composure and compound her fear. Still holding her, he did his best to sound reassuring.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Your contractions must have only started a couple of minutes ago.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She would have laughed at that if she’d had the strength. “A lot you know. They started early this morning.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She’d actually made a mental note to call Dr. Pollack as soon as she picked up the prescription she’d forgotten to get yesterday. She couldn’t seem to think clearly these days. Everything had gotten all jumbled ever since she’d received news of the car accident that had taken Holly and Brett out of her life and the lives of the children she was carrying.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_vm._v("Now it looked as if making the call was a moot point. If these contractions racking her body were ")]), _c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_vm._v("any indication of what was to come, these babies were going to be born long before Dr. Pollack could manage to get here.")])]), _c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She realized that Sebastian was asking her a question and tried to focus on it.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I said, how far apart are they?” he repeated, raising his voice. “The contractions,” he added for good measure. She looked so dazed he wasn’t sure if she was following him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Why?” She stared at him blankly. “Are you going to boil some water?” The sarcastic question came out of nowhere. In pain, angry, she just wanted to lash out at someone. His sudden reappearance after a seven-year absence and his close proximity made Sebastian the likeliest candidate.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m a doctor,” he told her simply, his mind working feverishly as he calculated the chances of his forgetting about waiting for the ambulance and just driving to the nearest hospital with Stephanie himself. “An ob-gyn.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("A doctor.")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The news stunned her enough to make her forget her pain, at least for a moment. He’d made it. He’d become a doctor. Pride slipped its arms around her, reaching across the bridge of years back from a time when such knowledge would have given her immense pleasure.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_vm._v("Clamping down on her pain, Stephanie looked at him. This is what he’d once told her he wanted to ")]), _c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_vm._v("be. Something her father had jeered he would never become. “So, you finally made it.”")])]), _c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The words were whispered, and at first he thought he’d imagined them. Raising his eyes, he looked at her. She’d always been the one who had faith in him. She and his mother.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yes, I did.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And then she was sinking against him, her energy obviously stolen by the force of the latest contraction. Balancing his medical bag in one hand, Sebastian scooped her up in his arms and looked around. He had to find someplace to make her comfortable.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Turning, he saw the woman he’d instructed to call 911 holding up her small cell phone in the air. “They’re coming,” she announced.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Good.” With any luck, they wouldn’t get here after the fact. But he was beginning to strongly doubt that.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As if reading his expression, a young redhead in tight jeans and an even tighter T-shirt waved to get his attention.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Here,” she called to him. “You can put her down inside my van.” Hurrying around to the rear of a light blue van, she unlocked the double doors and threw them open. “The floor covering doubles as a mattress,” she said proudly.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_vm._v("As people moved out of his way, Sebastian lost no time in crossing to the van. He managed to place Stephanie on the floor just as she sank all five nails ")]), _c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_vm._v("into his arm again. He could almost feel the impact of the contraction right along with her.")])]), _c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You rip my arm off, I’m not going to be able to use it to help you,” he warned, trying to summon a smile for her benefit. The result barely curved his mouth.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Getting into the van beside her, Sebastian crouched on his heels and reached for the doors. Stephanie was going to need privacy. His eyes met the woman’s. It was, after all, her van.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Thanks.” He indicated Stephanie beside him. “You want to come inside…?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But the woman was already backing away, her face growing slightly pale beneath the bold makeup she wore. As if afraid he’d pull her inside, she shoved her hands into her back pockets.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“That’s okay, I’ll just wait for the paramedics and tell them where you are.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("To forestall any further debate, the woman then closed both van doors herself, locking out the curious stares of the people who had not dispersed.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("They were alone. Alone in some stranger’s van. Alone with the hurtful past and a present that threatened to physically rip her in half. Stephanie wished she could get up and walk out, but that was totally beyond her power at the moment.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Still, she didn’t have to make this easy. “What makes you think I’m going to let you help me?” Her breathing began to grow more and more labored.")])]), _c('a', {
    attrs: {
      "id": "page31"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Same old Stevi, stubborn as hell.")]), _vm._v(" He tried to ignore the wave of affection that came out of nowhere.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I don’t think you have much of a choice in the matter, Stevi.” With effort, Sebastian drew her up until he had her back flush with the side of the van. It would be better for her this way, since there was no one to prop up her back. “Unless you want to do an imitation of a pioneer woman. In which case, I’ll take you over to the nearest wheat field and you can take it from there.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Perspiration was soaking not only her dress, but her scalp as well. Any second, it was going to start dripping into her eyes. She blinked it away. “You do have a black heart, you know that?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Despite the gravity of the situation, Sebastian looked at her for a long moment.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yes,” he said quietly, “I know. But that’s neither here nor there right now.” He looked around the interior of the van. Aside from what looked like a small laundry basket that was holding some canned goods, the van was pretty much empty. He would have preferred far less of a challenge. “You’re sure it’s twins?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m sure.” She began fisting her hands, bracing herself. “Either twins, or just about the biggest baby on record.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He saw her blanch and grasp for strands of the rug beneath her. “Another contraction?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page31"
    }
  }, [_vm._v("She could barely nod, concentrating hard on not letting this latest onslaught of pain tear her in half. ")]), _c('a', {
    attrs: {
      "id": "page32"
    }
  }, [_vm._v("She refused to be one of those screamers people were always ridiculing.")])]), _c('a', {
    attrs: {
      "id": "page32"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Maybe you…are…a doctor at that,” she panted. The contraction receded, leaving her more exhausted than it found her. Drained, she tried to collect herself sufficiently to prepare for the next one.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She had barely forty seconds.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Another one?” he asked incredulously. Her contractions were coming faster than he’d anticipated. The fastest birth he’d ever attended was just under three hours. This was beginning to have the makings of just under three minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Stephanie’s lips were dry and she felt them cracking as she bit into them. Nobody had warned her it was going to be this awful. But then, no one had told her she was going to be giving birth in a parked oven in the middle of a strip mall parking lot, attended by a man she wasn’t supposed to love any longer.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Sharp,” she retorted, vainly trying to grab something to hold on to. But there was nothing to wrap her hands around, nothing to help commute the force of the pain she felt.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Straining to hear the siren of an approaching ambulance he knew wouldn’t make it in time, Sebastian threw back the hem of her dress. Unless he missed his guess, the curtain was going up and it was show time.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A quick examination told him he’d guessed correctly. “You’re fully dilated.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page32"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Oh, boy, this was a big one. Don’t scream, don’t ")])]), _c('a', {
    attrs: {
      "id": "page33"
    }
  }, [_vm._v("scream, she thought frantically. “Tell…me…something…I don’t…know.”")])]), _c('a', {
    attrs: {
      "id": "page33"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Sebastian looked at her then, just one small, stray look spared in her direction. What would she say if he took her up on that? If he told her something she didn’t know? That he, despite all efforts to the contrary, still loved her. Would probably always love her no matter what, to the end of his days. That "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("he")]), _vm._v(" knew, and it was a cross he knew he had to bear.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But there was no point in sharing that with her. It was just something he was going to have to deal with himself.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Never could put anything over on you,” he murmured, looking around for a blanket or something to wrap around the babies, hoping that he’d overlooked one in the initial inspection of the van.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("There was nothing.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Sebastian!” Stephanie bit back a shriek as she clutched at his upper arm and arched her back, trying desperately to get as far away from the pain as she could. It only followed.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He hated seeing her like this, hated seeing pain etched into her features without being able to take it away.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It’ll be all right, Stevi.” Tenderness arrived out of nowhere, filling him as he brushed the damp hair away from her eyes. “I promise.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page33"
    }
  }, [_vm._v("“I want…that…in…writing.” Damn it, this was a lousy way to have a baby. Babies, she corrected ")]), _c('a', {
    attrs: {
      "id": "page34"
    }
  }, [_vm._v("herself. Orphaned and in a parking lot without so much as a clean sheet around to wrap them in.")])]), _c('a', {
    attrs: {
      "id": "page34"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("No, they weren’t orphaned. They had her. They would always have her, she vowed silently, her mind winking in and out, threatening to take consciousness with it. And she would give them all the love she had stored up in her heart. The love she’d never been allowed to give to anyone.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Sorry,” he told her, “afraid I can’t oblige you right now. You’re just going to have to take my word for it.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Panting, Stephanie struggled to keep from being steamrollered by the next contraction. Her eyes darted to his. His word. As if she could believe anything he said to her. He’d lied to her once, what was to keep him from lying again?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Not likely,” she breathed, arching again even though she knew it did no good. The pain found her no matter where she moved.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He heard her nails striking the floor’s metal border as she again tried to grab on to something to hold. There had to be something he could give her. He thought of his wallet. Pulling it out of his pocket, he wrapped his handkerchief around it.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Here, bite down on this.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page34"
    }
  }, [_vm._v("At any other time, she would have questioned his judgment, thinking he was crazy. But this wasn’t any other time, this was a unique, dire time and she needed something to help divert the pain, to channel ")]), _c('a', {
    attrs: {
      "id": "page35"
    }
  }, [_vm._v("the fearsome energy traveling through her body, however strange that “something” might be.")])]), _c('a', {
    attrs: {
      "id": "page35"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Grabbing the white linen-wrapped wallet, Stephanie clamped her teeth down on the slightly curved leather just as another contraction scooped her up and tossed her into its midst.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("This one was the worst ever.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He heard the muffled scream. Just like Stevi, trying so hard to get through this without a show of pain, he thought. Some things, apparently, never changed. She’d always hated a show of weakness, however justified.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Soon, Stevi, soon,” he promised.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Spitting out the wallet, she panted. “Soon… nothing…I…want this…over with…"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("now.")]), _vm._v("” Exhaustion threatened to overpower her as she fought to bring life into the world. “What’s…taking…so…long?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Long")]), _vm._v(" was a relative word, he thought. To him this was happening almost at lightning speed. “All right, I see a head, Stevi. On the count of three, I want you to push. You hear me?” Glancing up, he saw her nodding her head. “One, two—”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Pulling her shoulders in, Stephanie was pushing before he ever reached the last number, digging her knuckles into the thin floor padding and practically lifting herself off the floor.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page35"
    }
  }, [_vm._v("“Three,” Sebastian said even though it was after the fact. He glanced up to see her face growing red ")]), _c('a', {
    attrs: {
      "id": "page36"
    }
  }, [_vm._v("as she held her breath and strained with all her might. “All right, stop.”")])]), _c('a', {
    attrs: {
      "id": "page36"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Like a punctured balloon, Stephanie collapsed against the side of the van, panting not because it was part of the exercise, but because she couldn’t draw in enough air into her lungs. It felt as if she’d just run a ten-mile marathon in less than a minute.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m…beginning…to…understand…why…they…call…it…labor.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His mouth curved and he found himself wanting to hold her, to comfort her, but that wasn’t his function in this, nor was it his place. There was a husband out there somewhere, a husband who should have, by all rights, been attending this instead of him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The flash of jealousy was unexpected, uncalled-for and unprofessional. But it was there, nonetheless, red-hot and hard.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Sebastian forced himself to think like a doctor. “You’re doing fine, Stevi.” They were almost there. “Now I want you to push again. This time,” he cautioned, “wait until three.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She sneered at him. She was being torn apart and he was trying to make her obey orders like some kind of tin soldier or lapdog. She’d like to see him get through this insane tug-of-war she was experiencing.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("With a new contraction overtaking her before the old one left, Stephanie didn’t even wait until the count of two before she began to push again with all her might, this time lifting herself off the floor.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page36"
    }
  }, [_vm._v("“Stevi—” But it was too late. Sebastian could ")]), _c('a', {
    attrs: {
      "id": "page37"
    }
  }, [_vm._v("only pray she hadn’t ruptured something. “I’ve got the head, Stevi. Now push, push a little more.”")])]), _c('a', {
    attrs: {
      "id": "page37"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She didn’t think she could. Squeezing her eyes shut tight, she bore down again, biting back a guttural sound that echoed in her throat, demanding release.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“That a girl, Stevi, the baby’s coming.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I…already…know…that.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She had to push out the shoulders now. The hardest part. He tried to divert her attention from the pain he knew had to be consuming her. “Do you know the babies’ sex?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Didn’t…ask. It was…supposed to be…a surprise.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Holly and Brett had opted not to know, so she hadn’t asked to be told, either. Now she deeply regretted that they hadn’t found out when they’d had the chance. At least they would have known if they were the parents of boys or girls, or one of each. She ached for their loss. And her own.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Perspiration poured into her eyes, stinging them. Wasn’t this ever going to be over?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Out of the haze of pain, she heard Sebastian ordering her, “Push, Stevi, push.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("am!")]), _vm._v("” she shrieked, the cry bursting from her swollen lips.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Smooth as butter, Sebastian thought as the baby all but slid into his hands.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page37"
    }
  }, [_vm._v("Of course, he doubted that Stephanie felt that way about it, but then she was on the side that was doing ")]), _c('a', {
    attrs: {
      "id": "page38"
    }
  }, [_vm._v("all the work. Experiencing a myriad of feelings that only marginally had to do with the customary ones he felt whenever he attended the miracle of birth, Sebastian looked down at this latest citizen of the world.")])]), _c('a', {
    attrs: {
      "id": "page38"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Still want it to be kept a surprise?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No…damn it.” Was he cruel enough to play games when she was so exhausted? “What…is…it? Boy or girl?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You have a girl, Stevi.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He heard Stephanie suck in her breath. The second twin was on its way. Unable to hold the newborn, Sebastian took off his shirt and wrapped it around the baby. Quickly dumping out the canned goods, he placed her into the laundry basket.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“All right, let’s see if she has a little brother or sister.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Easy…for…you…to…say,” Stephanie managed to reply before the process began again in earnest, even harder this time than before. The pain ripped through her with long, sharp knives. “Oh, God, I’m…going…to…die.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Stephanie heard him draw in his breath, as if bracing himself for a fight. “Not on my shift you’re not.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She sincerely hoped Sebastian had learned to keep his word better than he had before.")])])]), _c('a', {
    attrs: {
      "id": "page38"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page38"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12faea34","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781426870323_ch02.vue
// module id = 75
// module chunks = 0